module.exports = __webpack_public_path__ + "static/img/img_4.48d0e6a9.png";